import React, { Component } from 'react';

import { Alert, Modal, ModalHeader, ModalBody, FormText, FormGroup, Button, ListGroup, ListGroupItem, Spinner, Col, Row } from "reactstrap"
import { AvForm, AvField } from 'availity-reactstrap-validation';

import { PayPalButton } from "react-paypal-button-v2";
import axios from "axios";

const MODE = {
    TEST: 0,
    DEMO: 1,
    LIVE: 2
}

const FORM = {
    ERROR: 0,
    USER_DETAILS: 1,
    DEMO_LINK: 2,
    PAYEMENT_DETAILS: 3,
    LICENCE_KEY: 4
}

const PRODUCT = {
    COPIER: "TTC",
    ROUTER: "TTR",
    BOTH: "TTC-TTR"
}

const MESSAGE_TYPE = {
    ERROR: 0,
    SUCCESS: 1,
    INFO: 2
}

class TrialRequestModal extends Component {
    // baseURL = `localhost:3800`
    baseURL = `https://licence.telegramtradecopier.com/amiin`
    constructor(props) {
        super(props);
        this.handleValidUserDetails = this.handleValidUserDetails.bind(this);
        this.handleInvalidUserDetails = this.handleInvalidUserDetails.bind(this);
        this.onModeSelect = this.onModeSelect.bind(this);
        this.onProductSelect = this.onProductSelect.bind(this);
        this.getHeader = this.getHeader.bind(this);
        this._toggleMoadal = this._toggleMoadal.bind(this);
        this.onPaymentButtonClick = this.onPaymentButtonClick.bind(this);
        this.getMessageColor = this.getMessageColor.bind(this);

        this.state = {
            inProgress: false,
            messageType: MESSAGE_TYPE.SUCCESS,
            message: undefined,
            form: FORM.USER_DETAILS,
            mode: MODE.TEST,
            product: PRODUCT.COPIER,
            userInput: {
                firstName: undefined,
                lastName: undefined,
                email: undefined,
                account: undefined,
                mode: undefined,
                product: undefined,
                telegramID: undefined
            }
        };
    }

    _toggleMoadal() {
        this.setState({
            messageType: MESSAGE_TYPE.SUCCESS,
            message: undefined,
            form: FORM.USER_DETAILS,
            mode: MODE.TEST,
            product: PRODUCT.COPIER,
            inProgress: false,
            userInput: {
                firstName: undefined,
                lastName: undefined,
                email: undefined,
                account: undefined,
                mode: undefined,
                product: undefined,
                telegramID: undefined
            }
        });
        this.props.togglemodal();
    }

    isSameTrialUser(user, name, email, telgramId) {
        if (user.name === name || user.email === email || user.username === telgramId) {
            return true;
        } else {
            return false;
        }
    }

    getModeStr() {
        switch (this.state.mode) {
            case MODE.LIVE:
                return "LIVE";
            case MODE.DEMO:
                return "DEMO";
            default:
                return "TEST";
        }
    }

    getProductPrice() {
        // alert('UPDATE PRICE')
        switch (this.state.mode) {
            case MODE.TEST:
                return "0.00";
            case MODE.DEMO:
                return "40.00";
            default:
                return "200.00";
        }
    }

    getMessageColor() {
        switch (this.state.messageType) {
            case MESSAGE_TYPE.SUCCESS:
                return "success";
            case MESSAGE_TYPE.INFO:
                return "info";
            default:
                return "danger";
        }
    }

    getProductName() {
        switch (this.state.product) {
            case PRODUCT.ROUTER:
                return `Telegram Trade Router - Recives signals from any telegram channel and routes to designated telegram channels`;
            case PRODUCT.BOTH:
                return `Telegram Trade Copier and Router - Recives signals from any telegram channel, forwards the signal to telegram channels and submit orders to MT4`;
            default:
                return `Telegram Trade Copier - Recives signals from any telegram channel and submit orders to MT4`;

        }
    }

    onModeSelect(event, value) {
        console.log(`onModeSelect ${value}`)
        let modeEnum = MODE.TEST;
        switch (value) {
            default:
                modeEnum = MODE.TEST;
                break;
            case "DEMO":
                modeEnum = MODE.DEMO;
                break;
            case "LIVE":
                modeEnum = MODE.LIVE;
                break;
        }
        this.setState({
            mode: modeEnum
        })
    }


    onProductSelect(event, value) {
        console.log(`onProductSelect ${value}`)

        this.setState({
            product: value
        })
    }

    //TODO - call REST api of signal-server to sendmail 
    handleValidUserDetails = async (event, values) => {
        if (this.state.mode !== MODE.TEST) {
            this.setState({
                messageType: MESSAGE_TYPE.SUCCESS,
                form: FORM.PAYEMENT_DETAILS,
                message: {
                    status: `Your licence key for Telegram Trade Copier ${this.getModeStr()} is ready !!!.`,
                    action: `Please confirm your order details below and proceed with the payment `,
                    fallback: `You will be charged ${this.getProductPrice()}$ and The licence key will be sent to your email and to your telegram account`
                },
                userInput: {
                    firstName: values.firstName,
                    lastName: values.lastName,
                    email: values.email,
                    mode: this.getModeStr(),
                    account: values.accountDetails,
                    product: this.state.product,
                    telegramID: values.telegramID,
                    version: "2.0.0"
                }
            })
        } else {
            const userInput = {
                email: values.email,
                mode: this.getModeStr(),
                product: this.state.product,
                telegramID: values.telegramID
            }

            let axiosPayload = {
                baseURL: this.baseURL,
                url: `/admin/demo`,
                method: 'post',
                data: userInput,
                maxContentLength: 100000000
            };
            let response;
            try {
                response = await axios(axiosPayload);
                if (response.status === 200 && response.statusText === "OK" && response.data.status === "ok") {
                    console.log(`Please activate your ${this.getModeStr()} Telegram Trade Copier using below key`);
                    this.setState({
                        messageType: MESSAGE_TYPE.INFO,
                        isAlert: false,
                        form: FORM.DEMO_LINK,
                        userInput: userInput,
                        message: {
                            status: `The download link is sent to ${values.email} email address.`,
                            action: `Please download the application and follow the video/text guide to setup in the website`,
                            fallback: `contact support for further assitance`,
                            link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                        },
                    })
                } else {
                    this.setState({
                        messageType: MESSAGE_TYPE.ERROR,
                        isAlert: true,
                        form: FORM.ERROR,
                        userInput: userInput,
                        message: {
                            status: `Your free test licence quota is exceeded`,
                            action: `Please contact the support for get extention of your licence`,
                            fallback: ``,
                            link: ``
                        },
                    })
                }
            } catch (e) {
                console.log('Error ', e);
            }

        }
    }

    handleInvalidUserDetails(event, values) {
        this.setState({
            messageType: MESSAGE_TYPE.ERROR,
            message: {
                status: `Entered invalid information.`,
                action: ``,
                fallback: `Please inspect the error messages and submit again`,
                link: ``
            },
        })
    }

    getHeader(form) {
        switch (form) {
            case FORM.DEMO_LINK:
                return "Thank you for trying out Telegram Trade Copier";
            case FORM.PAYEMENT_DETAILS:
                return "Please select your payment method";
            case FORM.LICENCE_KEY:
                return "Welcome Onboard";
            default:
                return "Submit your request";
        }
    }

    onPaymentButtonClick() {
        console.log(`onPaymentButtonClick`);
        // this.setState({
        //     inProgress: true
        // })
    }

    onSuccess = async (details, data) => {
        console.log(`Payment Recived DETAILS-${details} DATA-${data}`);

        const paymentStatus = details.status;
        if (paymentStatus === "COMPLETED") {
            if (details.purchase_units.length === 1) {
                const paidAmount = details.purchase_units[0].amount.value;
                const paidCurrency = details.purchase_units[0].amount.currency_code;
                const orderID = data.orderID;
                const payerID = data.payerID;
                const payerName = `${details.payer.name.given_name} ${details.payer.name.surname}`;
                
                const payerAccID =  details.payer.email_address.split('@');
                const lastFourChar = payerAccID[0].toString().substring(payerAccID[0].length - 4)
                const domain = payerAccID[1];
                const payerAccountID = `${lastFourChar}@${domain}`;

                this.setState({
                    inProgress: true,
                    txDetails: {
                        orderID:  orderID,
                        payerID:  payerID,
                        payerName: payerName,
                        payerAccountID: payerAccountID,
                        paymentSource: 'PayPal account',
                        paidAmount: paidAmount,
                        paidCurrency: paidCurrency,
                    } 
                })

                if (parseInt(paidAmount) === parseInt(this.getProductPrice()) && paidCurrency === "USD") {
                    console.log("Succefull payment", details, " data ", data);

                    
                    let axiosPayload = {
                        baseURL: this.baseURL,
                        url: `/admin/generate`,
                        method: 'post',
                        data: {
                            userInput: this.state.userInput,
                            txDetails: this.state.txDetails
                        },
                        maxContentLength: 10000000
                    }                   

                    let response = await axios(axiosPayload);
                    if (response.status === 200 && response.statusText === "OK" && response.data.status === "ok") {
                        console.log(`Please activate your ${this.getModeStr()} Telegram Trade Copier using below key`);
                        this.setState({
                            form: FORM.LICENCE_KEY,
                            messageType: MESSAGE_TYPE.SUCCESS,
                            message: {
                                status: `Licence for  ${this.getModeStr()} Telegram Trade Copier is issued succesfully !!!`,
                                action: `Please check your email ${this.state.userInput.email} for furthur instructions to activate the licence.`,
                                fallback: `If you didn't recive the email within 15 minutes or for assitance to activate the licence, Please contact us`,
                                link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                            },
                            inProgress: false
                        })
                    } else {
                        console.log(`Invalid payment detected. Purchased key is not found in the system`);
                        this.setState({
                            form: FORM.ERROR,
                            messageType: MESSAGE_TYPE.ERROR,
                            message: {
                                status: `Something went wrong from our side`,
                                action: `Please contact us with order id ${this.state.txDetails.orderID}, payer id ${payerID}`,
                                fallback: `Don't worry we support you 24/7, Contact anytime for resolutions`,
                                link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                            },
                            inProgress: false
                        })
                        //TODO cancel the payment
                    }

                } else {
                    console.log(`Invalid payment detected. Expected amount is ${this.getProductPrice()} in USD but recived payment of ${paidAmount} in ${paidCurrency}`);
                    this.setState({
                        form: FORM.ERROR,
                        messageType: MESSAGE_TYPE.ERROR,
                        message: {
                            status: `Invalid payment detected. Expected amount is ${this.getProductPrice()} in USD but recived payment of ${paidAmount} in ${paidCurrency}`,
                            action: `Please cancel the order, request a refund or Contact us`,
                            fallback: `Don't worry we support you 24/7, Contact anytime for resolutions`,
                            link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                        },
                        inProgress: false
                    })
                }
            } else {
                console.log(`Invalid payment detected. Expected single item in the payment but recived payment for multiple items`);

                this.setState({
                    form: FORM.ERROR,
                    messageType: MESSAGE_TYPE.ERROR,
                    message: {
                        status: `Something went wrong in the order, Expected single item in the payment but recived payment for multiple items`,
                        action: `Please cancel the order, request a refund or Contact us`,
                        fallback: `Don't worry we support you 24/7, Contact anytime for resolutions`,
                        link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                    },
                    inProgress: false
                })
            }
        } else {
            console.log(`Invalid payment detected. Payemnt is not completed`);
            this.setState({
                hasError: false,
                isSuccess: true,
                success: "Please click on your download link to download the free trial of TelegramTradeCopier."
            })
        }                       
    }

    handleInvalidUserDetails(event, values) {
        this.setState({
            messageType: MESSAGE_TYPE.ERROR,
            message: {
                status: `Entered invalid information.`,
                action: ``,
                fallback: `Please inspect the error messages and submit again`,
                link: ``
            },
        })
    }

    getHeader(form) {
        switch (form) {
            case FORM.DEMO_LINK:
                return "Thank you for trying out Telegram Trade Copier";
            case FORM.PAYEMENT_DETAILS:
                return "Please select your payment method";
            case FORM.LICENCE_KEY:
                return "Welcome Onboard";
            default:
                return "Submit your request";
        }
    }

    onPaymentButtonClick() {
        console.log(`onPaymentButtonClick`);
        // this.setState({
        //     inProgress: true
        // })
    }

    onSuccess = async (details, data) => {
        console.log(`Payment Recived DETAILS-${details} DATA-${data}`);

        const paymentStatus = details.status;
        if (paymentStatus === "COMPLETED") {
            if (details.purchase_units.length === 1) {
                const paidAmount = details.purchase_units[0].amount.value;
                const paidCurrency = details.purchase_units[0].amount.currency_code;
                const orderID = data.orderID;
                const payerID = data.payerID;
                const payerName = `${details.payer.name.given_name} ${details.payer.name.surname}`;
                
                const payerAccID =  details.payer.email_address.split('@');
                const lastFourChar = payerAccID[0].toString().substring(payerAccID[0].length - 4)
                const domain = payerAccID[1];
                const payerAccountID = `${lastFourChar}@${domain}`;

                if (parseInt(paidAmount) === parseInt(this.getProductPrice()) && paidCurrency === "USD") {
                    console.log("Succefull payment", details, " data ", data);

                    this.setState({
                        inProgress: true,
                        txDetails: {
                            orderID:  orderID,
                            payerID:  payerID,
                            payerName: payerName,
                            payerAccountID: payerAccountID,
                            paymentSource: 'PayPal account',
                            paidAmount: paidAmount,
                            paidCurrency: paidCurrency,
                        } 
                    })

                    let axiosPayload = {
                        baseURL: this.baseURL,
                        url: `/admin/generate`,
                        method: 'post',
                        data: {
                            userInput: this.state.userInput,
                            txDetails: this.state.txDetails
                        },
                        maxContentLength: 10000000
                    }                   

                    let response = await axios(axiosPayload);
                    if (response.status === 200 && response.statusText === "OK" && response.data.status === "ok") {
                        console.log(`Please activate your ${this.getModeStr()} Telegram Trade Copier using below key`);

                        this.setState({
                            form: FORM.LICENCE_KEY,
                            messageType: MESSAGE_TYPE.SUCCESS,
                            message: {
                                status: `Licence for  ${this.getModeStr()} Telegram Trade Copier is issued succesfully !!!`,
                                action: `Please check your email ${this.state.userInput.email} for furthur instructions to activate the licence.`,
                                fallback: `If you didn't recive the email within 15 minutes or for assitance to activate the licence, Please contact us`,
                                link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                            },
                            inProgress: false
                        })
                    } else {
                        console.log(`Invalid payment detected. Purchased key is not found in the system`);
                        this.setState({
                            form: FORM.ERROR,
                            messageType: MESSAGE_TYPE.ERROR,
                            message: {
                                status: `Something went wrong from our side, Purchased key is not found in the system`,
                                action: `Please cancel the order, request a refund or Contact us`,
                                fallback: `Don't worry we support you 24/7, Contact anytime for resolutions`,
                                link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                            },
                            inProgress: false
                        })
                    }

                } else {
                    console.log(`Invalid payment detected. Expected amount is ${this.getProductPrice()} in USD but recived payment of ${paidAmount} in ${paidCurrency}`);
                    this.setState({
                        form: FORM.ERROR,
                        messageType: MESSAGE_TYPE.ERROR,
                        message: {
                            status: `Invalid payment detected. Expected amount is ${this.getProductPrice()} in USD but recived payment of ${paidAmount} in ${paidCurrency}`,
                            action: `Please cancel the order, request a refund or Contact us`,
                            fallback: `Don't worry we support you 24/7, Contact anytime for resolutions`,
                            link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                        },
                        inProgress: false
                    })
                }
            } else {
                console.log(`Invalid payment detected. Expected single item in the payment but recived payment for multiple items`);

                this.setState({
                    form: FORM.ERROR,
                    messageType: MESSAGE_TYPE.ERROR,
                    message: {
                        status: `Something went wrong in the order, Expected single item in the payment but recived payment for multiple items`,
                        action: `Please cancel the order, request a refund or Contact us`,
                        fallback: `Don't worry we support you 24/7, Contact anytime for resolutions`,
                        link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                    },
                    inProgress: false
                })
            }
        } else {
            console.log(`Invalid payment detected. Payemnt is not completed`);
            this.setState({
                hasError: false,
                isSuccess: true,
                success: "Please click on your download link to download the free trial of TelegramTradeCopier."
            })
        }                       
    }

    handleInvalidUserDetails(event, values) {
        this.setState({
            messageType: MESSAGE_TYPE.ERROR,
            message: {
                status: `Entered invalid information.`,
                action: ``,
                fallback: `Please inspect the error messages and submit again`,
                link: ``
            },
        })
    }

    getHeader(form) {
        switch (form) {
            case FORM.DEMO_LINK:
                return "Thank you for trying out Telegram Trade Copier";
            case FORM.PAYEMENT_DETAILS:
                return "Please select your payment method";
            case FORM.LICENCE_KEY:
                return "Welcome Onboard";
            default:
                return "Submit your request";
        }
    }

    onPaymentButtonClick() {
        console.log(`onPaymentButtonClick`);
        // this.setState({
        //     inProgress: true
        // })
    }

    onSuccess = async (details, data) => {
        console.log(`Payment Recived DETAILS-${details} DATA-${data}`);

        const paymentStatus = details.status;
        if (paymentStatus === "COMPLETED") {
            if (details.purchase_units.length === 1) {
                const paidAmount = details.purchase_units[0].amount.value;
                const paidCurrency = details.purchase_units[0].amount.currency_code;
                const orderID = data.orderID;
                const payerID = data.payerID;
                const payerName = `${details.payer.name.given_name} ${details.payer.name.surname}`;

                const payerAccID =  details.payer.email_address.split('@');
                const lastFourChar = payerAccID[0].toString().substring(payerAccID[0].length - 4)
                const domain = payerAccID[1];
                const payerAccountID = `${lastFourChar}@${domain}`;

                if (parseInt(paidAmount) === parseInt(this.getProductPrice()) && paidCurrency === "USD") {
                    console.log("Succefull payment", details, " data ", data);

                    this.setState({
                        inProgress: true,
                        txDetails: {
                            orderID:  orderID,
                            payerID:  payerID,
                            payerName: payerName,
                            payerAccountID: payerAccountID,
                            paymentSource: 'PayPal account',
                            paidAmount: paidAmount,
                            paidCurrency: paidCurrency,
                        } 
                    })

                    let axiosPayload = {
                        baseURL: this.baseURL,
                        url: `/admin/generate`,
                        method: 'post',
                        data: {
                            userInput: this.state.userInput,
                            txDetails: this.state.txDetails
                        },
                        maxContentLength: 10000000
                    }                   

                    let response = await axios(axiosPayload);
                    if (response.status === 200 && response.statusText === "OK" && response.data.status === "ok") {
                        console.log(`Please activate your ${this.getModeStr()} Telegram Trade Copier using below key`);

                        this.setState({
                            form: FORM.LICENCE_KEY,
                            messageType: MESSAGE_TYPE.SUCCESS,
                            message: {
                                status: `Licence for  ${this.getModeStr()} Telegram Trade Copier is issued succesfully !!!`,
                                action: `Please check your email ${this.state.userInput.email} for furthur instructions to activate the licence.`,
                                fallback: `If you didn't recive the email within 15 minutes or for assitance to activate the licence, Please contact us`,
                                link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                            },
                            inProgress: false
                        })
                    } else {
                        console.log(`Invalid payment detected. Purchased key is not found in the system`);
                        this.setState({
                            form: FORM.ERROR,
                            messageType: MESSAGE_TYPE.ERROR,
                            message: {
                                status: `Something went wrong from our side, Purchased key is not found in the system`,
                                action: `Please cancel the order, request a refund or Contact us`,
                                fallback: `Don't worry we support you 24/7, Contact anytime for resolutions`,
                                link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                            },
                            inProgress: false
                        })
                    }

                } else {
                    console.log(`Invalid payment detected. Expected amount is ${this.getProductPrice()} in USD but recived payment of ${paidAmount} in ${paidCurrency}`);
                    this.setState({
                        form: FORM.ERROR,
                        messageType: MESSAGE_TYPE.ERROR,
                        message: {
                            status: `Invalid payment detected. Expected amount is ${this.getProductPrice()} in USD but recived payment of ${paidAmount} in ${paidCurrency}`,
                            action: `Please cancel the order, request a refund or Contact us`,
                            fallback: `Don't worry we support you 24/7, Contact anytime for resolutions`,
                            link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                        },
                        inProgress: false
                    })
                }
            } else {
                console.log(`Invalid payment detected. Expected single item in the payment but recived payment for multiple items`);

                this.setState({
                    form: FORM.ERROR,
                    messageType: MESSAGE_TYPE.ERROR,
                    message: {
                        status: `Something went wrong in the order, Expected single item in the payment but recived payment for multiple items`,
                        action: `Please cancel the order, request a refund or Contact us`,
                        fallback: `Don't worry we support you 24/7, Contact anytime for resolutions`,
                        link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                    },
                    inProgress: false
                })
            }
        } else {
            console.log(`Invalid payment detected. Payemnt is not completed`);
            this.setState({
                form: FORM.ERROR,
                messageType: MESSAGE_TYPE.ERROR,
                message: {
                    status: `Invalid payment detected. Expected status is COMPLETED but the payment status is ${paymentStatus}`,
                    action: `Please check your account balance and details and re try`,
                    fallback: `Contact us`,
                    link: `https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT`
                },
                inProgress: false
            })
        }
    }

    onButtonReady = (details, data) => {
        console.log(`onButtonReady`, details, data);
    }

    onError = (details, data) => {
        console.log(`onError`, details, data);
    }

    onApprove = (details, data) => {
        console.log(`onApprove`, details, data);
    }

    render() {
        const userDetails = (
            <div className="feature-form">
                <div className="content mt-4 pt-2">
                    <AvForm
                        onValidSubmit={this.handleValidUserDetails}
                        onInvalidSubmit={this.handleInvalidUserDetails}
                    >
                        <AvField type="select" name="product" label="Product" helpMessage="Select the product" value={this.state.product} onChange={this.onProductSelect}>
                            <option selected={true} value={PRODUCT.COPIER}>Telegram Trade Copier - TTC</option>
                            {/* <option value={PRODUCT.ROUTER}>Telegram Trade Router - TTR</option>
                            <option value={PRODUCT.BOTH}>Telegram Trade Router and Copier - TTC and TSR</option> */}
                        </AvField>
                        <AvField type="select" name="mode" label="Type" helpMessage="Select the product type" value={MODE[this.state.mode]} onChange={this.onModeSelect}>
                            <option selected={true} value="TEST">TEST - Lifetime connectivty and message format testing application - FREE</option>
                            <option value="DEMO">DEMO - One Month MT4 demo trading licence - 40 USD</option>
                            <option value="LIVE">LIVE - Lifetime MT4 real and unlimited demo trading licence - 200 USD</option>
                        </AvField>
                        <FormGroup>
                            <AvField
                                name="email"
                                label="Email"
                                type="email"
                                helpMessage="Enter a valid email address, Confidentail information will be sent here."
                                validate={{
                                    required: {
                                        value: true,
                                        errorMessage: 'Email is required'
                                    }
                                }}
                            />
                        </FormGroup>
                        {
                            (this.state.mode === MODE.LIVE || this.state.mode === MODE.DEMO) ?
                                <span>
                                    <FormGroup>
                                        <AvField
                                            name="firstName"
                                            label="First Name"
                                            helpMessage="First name of the licence owners"
                                            type="text"
                                            validate={{
                                                required: {
                                                    value: true,
                                                    errorMessage: 'First name is required'
                                                }
                                            }}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <AvField
                                            name="lastName"
                                            label="Last Name"
                                            helpMessage="Last name of the licence owners"
                                            type="text"
                                            validate={{
                                                required: {
                                                    value: true,
                                                    errorMessage: 'Last name is required'
                                                }
                                            }}
                                        />
                                    </FormGroup>

                                </span>
                                : ''
                        }

                        {
                            this.state.mode === MODE.LIVE && (this.state.product === "TTC" || this.state.product === "TTC-TTR") ?
                                <FormGroup>
                                    <AvField
                                        name="accountDetails"
                                        label="MT4 account id"
                                        helpMessage="MT4 account id the license issued"
                                        validate={{
                                            required: {
                                                value: true,
                                                errorMessage: 'MT4 account id is required'
                                            },
                                            pattern: {
                                                value: '^[0-9]*$',
                                                errorMessage: 'Your account number must be composed only with numbers'
                                            },
                                        }}
                                    />
                                </FormGroup>
                                : ''
                        }
                        {
                            (this.state.mode === MODE.LIVE && (this.state.product === "TTR" || this.state.product === "TTC-TTR")) ?
                                <span>
                                    <FormGroup>
                                        <AvField
                                            name="channelList"
                                            label="Channels To Publish"
                                            type="text"
                                            validate={{
                                                required: {
                                                    value: true,
                                                    errorMessage: 'Channel name(s) are required'
                                                }
                                            }}
                                        />
                                    </FormGroup>
                                    <FormText>Enter the comma seperated channel list.</FormText>
                                </span>
                                : ''
                        }
                        <FormGroup>
                            <AvField
                                name="telegramID"
                                label="Telegram phone number (With country code)"
                                helpMessage="Enter a valid Telegram Phone Number, Confidentail information will be sent here."
                                validate={{
                                    required: {
                                        value: true,
                                        errorMessage: 'Telegram number is required'
                                    },
                                    pattern: {
                                        value: '^[0-9,+]*$',
                                        errorMessage: 'Your number must be composed only with + and numbers'
                                    },
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            {/* Set up a container element for the button  */}
                            <Button id="demoSection-demo-request-btn" className="btn primary">
                                {
                                    (this.state.mode === MODE.LIVE || this.state.mode === MODE.DEMO) ?
                                        'Buy Now'
                                        :
                                        'Request A Demo'
                                }
                            </Button>
                        </FormGroup>
                    </AvForm>
                </div>
            </div>
        )

        const paymentButtons = (
            <div style={{ fontFamily: "monospace" }}>
                <Row>
                    <Col md={{ size: 9, order: 1, offset: 1 }}>
                        <ListGroup flush>

                            <ListGroupItem >
                                <Row>
                                    <Col md={{ size: 3, order: 1, offset: 1 }}>
                                        {"Name:"}
                                    </Col>
                                    <Col md={{ size: 4, order: 2 }}>
                                        {this.state.userInput.lastName} {this.state.userInput.firstName}
                                    </Col>
                                </Row>
                            </ListGroupItem>
                            <ListGroupItem >
                                <Row>
                                    <Col md={{ size: 3, order: 1, offset: 1 }}>
                                        {"Email:"}
                                    </Col>
                                    <Col md={{ size: 8, order: 2 }}>
                                        {this.state.userInput.email}
                                    </Col>
                                </Row>
                            </ListGroupItem>
                            <ListGroupItem >
                                <Row>
                                    <Col md={{ size: 3, order: 1, offset: 1 }}>
                                        {"Telegram ID:"}
                                    </Col>
                                    <Col md={{ size: 8, order: 2 }}>
                                        {this.state.userInput.telegramID}
                                    </Col>
                                </Row>
                            </ListGroupItem>
                            <ListGroupItem>
                                <Row>
                                    <Col md={{ size: 3, order: 1, offset: 1 }}>
                                        {"Product Name:"}
                                    </Col>
                                    <Col md={{ size: 8, order: 2 }}>
                                        {this.getProductName()}
                                    </Col>

                                </Row>
                            </ListGroupItem>
                            <ListGroupItem >
                                <Row>
                                    <Col md={{ size: 3, order: 1, offset: 1 }}>
                                        {"Product Type:"}
                                    </Col>
                                    <Col md={{ size: 8, order: 2 }}>
                                        {this.getModeStr()}
                                    </Col>
                                </Row>
                            </ListGroupItem>
                            <ListGroupItem>
                                <Row>
                                    <Col md={{ size: 3, order: 1, offset: 1 }}>
                                        {"Charge:"}
                                    </Col>
                                    <Col md={{ size: 8, order: 2 }}>
                                        {this.getProductPrice()} USD
                                    </Col>
                                </Row>
                            </ListGroupItem>
                        </ListGroup>
                    </Col>
                </Row>

                <span className="text-center" >
                    <PayPalButton
                        onClick={this.onPaymentButtonClick}
                        amount={parseFloat(this.getProductPrice())}
                        currency={'USD'}
                        onError={this.onError}
                        onApprove={this.onApprove}
                        onButtonReady={this.onButtonReady}
                        onSuccess={this.onSuccess}
                        options={{
                            clientId: "AWMkvLSrVigVrtWymxM00foOAWBAzgDWNEnk9P6wyLGJ2zLrA37RfQZUR5nR2us73LCr-MVcDIHmRCAj"
                        }}
                    />
                </span>
            </div>
        )

        const inProgressSpinner = (
            <div className="text-center">
                <h1><Spinner type="grow" color="success" /></h1>
            </div>
        )

        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} role="dialog" autoFocus={true} centered={true} id="trialform" tabIndex="-1">
                    <div className="modal-content rounded shadow border-0">
                        <ModalHeader toggle={this._toggleMoadal}>
                            {
                                this.getHeader(this.state.form)
                            }

                        </ModalHeader>
                        <ModalBody>
                            {
                                this.state.message ?
                                    <span>
                                        <Alert isOpen={this.state.message !== undefined && this.state.inProgress === false} color={this.getMessageColor()}>
                                            <h4>{this.state.message.status}</h4>
                                        </Alert>
                                        <p style={{ color: "ash", textAlign: "center" }}>{this.state.message.action}</p>
                                        {
                                            this.state.message.link ?
                                                <a href={this.state.message.link} target="_blank" rel="noopener noreferrer" className="video-play-icon h6 text-primary">
                                                    <span className="text-primary font-weight-bold">
                                                        <p style={{ color: "blue", textAlign: "center" }}>{this.state.message.fallback}</p>
                                                    </span>
                                                </a>
                                                :
                                                <span className="text-primary font-weight-bold">
                                                    <p style={{ color: "blue", textAlign: "center" }}>{this.state.message.fallback}</p>
                                                </span>
                                        }

                                    </span>
                                    : ''
                            }
                            {

                                this.state.form === FORM.ERROR ? '' :
                                    this.state.form === FORM.LICENCE_KEY ? '' :
                                        this.state.form === FORM.DEMO_LINK ? '' :
                                            this.state.form === FORM.USER_DETAILS ? userDetails :
                                                this.state.form === FORM.PAYEMENT_DETAILS ? paymentButtons :
                                                    this.state.inProgress ? inProgressSpinner : ''
                            }
                        </ModalBody>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

export default TrialRequestModal;